/**
 * Slug for the tenant subdomain from "Nome fantasia".
 * Lowercase, strip accents, spaces → "-", keep [a-z0-9-].
 */
export function slugifyTenantDomain(name) {
  return String(name || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-');
}

/**
 * Auto-fill domain from name while the domain still matches the previous
 * auto-slug (or is empty). Stops once the user edits domain manually.
 */
export function nextDomainFromNameChange({ previousName, previousDomain, nextName }) {
  const slug = slugifyTenantDomain(nextName);
  const previousSlug = slugifyTenantDomain(previousName);
  const shouldSync = !previousDomain || previousDomain === previousSlug;
  return shouldSync ? slug : previousDomain;
}
